<div class="d-flex flex-nowrap flex-column justify-content-center align-items-stretch h-100 w-100 m-0 main-authentication">

    <div class="mx-auto align-self-center col-11 col-sm-11 col-md-10 col-lg-8 col-xl-6 col-xxl-5">

        <mat-card appearance="outlined">

            <!-- Header -->
            <mat-card-header class="d-flex flex-row justify-content-center align-items-center h-100 w-100 pt-3 pb-5">
                <mat-card-title>
                    <img [src]="urlLogo" alt="ICAI-ICADE" class="main-authentication-logo img-fluid">
                </mat-card-title>
            </mat-card-header>

            <!-- Content -->
            <mat-card-content class="main-authentication-content">
                <router-outlet></router-outlet>
            </mat-card-content>

        </mat-card>

    </div>

<div>
